import React, { useState, useEffect } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'axios';
import moment from 'moment';
import { Link, useNavigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../config/firebase';
import IconButton from 'components/common/IconButton';
import PageHeader from 'components/common/PageHeader';
import FalconComponentCard from 'components/common/FalconComponentCard';
import positions from '../../config/positions';
import commtypes from '../../config/commtypes';
import genders from '../../config/genders';
import parties from '../../config/parties';
import titles from '../../config/titles';
import statuses from '../../config/statuses';
import FileUpload from 'components/doc-components/FileUpload';

const EditMember = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [fileUrlImage, setFileUrlImage] = useState(null);
  const [formData, setFormData] = useState({
    title: 'Mr',
    name: '',
    surname: '',
    gender: 'M',
    status: 'Active',
    user_id: null,
    party_id: '1',
    tel: '',
    cell1: '',
    cell2: '',
    email1: '',
    email2: '',
    website: '',
    facebook: '',
    twitter: '',
    whatsapp: '',
    preffered: 'Email',
    position_id: '48',
    profile_pic_url: '',
    hierarchy_position: '',
    hierarchy_chairperson_position: '',
    birthdateDD: '',
    birthdateMM: '',
    birthdateYYYY: '',
    updated_at: moment().format('YYYY-MM-DD HH:mm'),
  });

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const uid = user.uid;
        setFormData({
          ...formData,
          user_id: uid,
        });
      } else {
        navigate('/login');
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const id = window.location.pathname.split('/').pop();

      if (id) {
        try {
          const apiUrl = `${process.env.REACT_APP_API_URL}`;
          const response = await axios.get(`${apiUrl}/members/id/${id}`);

          if (response.data.length > 0) {
            const eventData = response.data[0];

            setFormData({
              name: eventData.name,
              surname: eventData.surname,
              title: eventData.title,
              gender: eventData.gender,
              status: eventData.status ?? 'Active',
              updated_at: eventData.updated_at,
              user_id: eventData.user_id,
              party_id: eventData.party_id,
              tel: eventData.tel ?? '',
              cell1: eventData.cell1 ?? '',
              cell2: eventData.cell2 ?? '',
              email1: eventData.email1 ?? '',
              email2: eventData.email2 ?? '',
              website: eventData.website ?? '',
              facebook: eventData.facebook ?? '',
              twitter: eventData.twitter ?? '',
              whatsapp: eventData.whatsapp ?? '',
              preffered: eventData.preffered ?? '',
              position_id: eventData.position_id ?? '48',
              profile_pic_url: eventData.profile_pic_url ?? '',
              hierarchy_position: eventData.hierarchy_position ?? null,
              hierarchy_chairperson_position: eventData.hierarchy_chairperson_position,
              dob: eventData?.dob,
              birthdateDD: eventData.dob ? eventData.dob.split('/')[0] : '',
              birthdateMM: eventData.dob ? eventData.dob.split('/')[1] : '',
              birthdateYYYY: eventData.dob ? eventData.dob.split('/')[2] : '',
            });
            setLoading(false);
          }
        } catch (err) {
          console.log('Error', err);
        }
      } else {
        navigate('/members/list');
      }
    };

    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const birthdate = `${formData.birthdateDD}/${formData.birthdateMM}/${formData.birthdateYYYY}`;
    const { birthdateDD, birthdateMM, birthdateYYYY } = formData;
    const inputDate = new Date(birthdateYYYY, birthdateMM - 1, birthdateDD);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // set time to 00:00:00.000

    try {
      if (inputDate > today || birthdateYYYY > today.getFullYear() || birthdateMM > 12 || birthdateDD > 31) {
        toast.error('Date of birth is invalid.');
        return;
      }
    } catch (error) {
      toast.error('Date of birth is invalid.');
      return;
    }

    try {
      let formData2 = new FormData();
      formData2.append('title', formData.title);
      formData2.append('name', formData.name);
      formData2.append('surname', formData.surname);
      formData2.append('gender', formData.gender);
      formData2.append('dob', birthdate);
      formData2.append('position_id', formData.position_id);
      formData2.append('created_at', formData.created_at && moment.utc(formData.created_at).format('YYYY-MM-DD HH:mm'));
      formData2.append('updated_at', formData.updated_at && moment.utc(formData.updated_at).format('YYYY-MM-DD HH:mm'));
      formData2.append('fileUrlImage', fileUrlImage ?? formData.profile_pic_url);
      formData2.append('profile_pic_url', fileUrlImage ?? formData.profile_pic_url);
      formData2.append('status', formData.status);
      formData2.append('tel', formData.tel);
      formData2.append('cell1', formData.cell1);
      formData2.append('cell2', formData.cell2);
      formData2.append('email1', formData.email1);
      formData2.append('email2', formData.email2);
      formData2.append('website', formData.website);
      formData2.append('facebook', formData.facebook);
      formData2.append('twitter', formData.twitter);
      formData2.append('whatsapp', formData.whatsapp);
      formData2.append('preffered', formData.preffered);
      formData2.append('hierarchy_position', formData.hierarchy_position);
      formData2.append('hierarchy_chairperson_position', formData.hierarchy_chairperson_position);
      formData2.append('party_id', formData.party_id);
      formData2.append('user_id', formData.user_id);

      const apiUrl = `${process.env.REACT_APP_API_URL}`;
      const id = window.location.pathname.split('/').pop();

      const response = await axios.put(`${apiUrl}/members/id/${id}`, formData2);
      if (response.data.data === 'Member updated') {
        toast.success(`Member updated successfully`, {
          theme: 'colored',
        });
        navigate('/members/list');
      }
    } catch (err) {
      console.log('Error', err.message);
    }
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    if (name === 'post_date') {
      const dateValue = moment.utc(value).format('YYYY-MM-DD HH:mm');
      setFormData({
        ...formData,
        [name]: dateValue,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  return (
    <>
      <PageHeader
        title="Edit a Member"
        description="The updated Member details will be shown on the Member's page"
        className="mb-3"
      ></PageHeader>

      <FalconComponentCard>
        <FalconComponentCard.Header title="Details" light={false} noPreview={true}></FalconComponentCard.Header>
        <Form onSubmit={handleSubmit}>
          {!loading && (
            <FalconComponentCard.Body>
              <Row>
                <Col lg="4">
                  <Form.Group>
                    <Form.Label>Title</Form.Label>
                    <Form.Select
                      size="md"
                      className="mb-3"
                      name="title"
                      required
                      onChange={handleFieldChange}
                      defaultValue={formData.title}
                    >
                      {titles.map((title) => (
                        <option key={title.name} value={title.value}>
                          {title.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col lg="4">
                  <Form.Group>
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      size="lg"
                      type="text"
                      placeholder=""
                      name="name"
                      required
                      onChange={handleFieldChange}
                      defaultValue={formData.name}
                    />
                  </Form.Group>
                </Col>
                <Col lg="4">
                  <Form.Group>
                    <Form.Label>Surname</Form.Label>
                    <Form.Control
                      size="lg"
                      type="text"
                      placeholder=""
                      name="surname"
                      required
                      onChange={handleFieldChange}
                      defaultValue={formData.surname}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col lg="6">
                  <Form.Group>
                    <Form.Label>Date of birth</Form.Label>
                    <Row>
                      <Col>
                        <Form.Control
                          maxLength="2"
                          size="lg"
                          type="text"
                          placeholder="DD"
                          name="birthdateDD"
                          onChange={handleFieldChange}
                          defaultValue={formData.birthdateDD}
                          required
                        />
                      </Col>
                      <Col>
                        <Form.Control
                          maxLength="2"
                          size="lg"
                          type="text"
                          placeholder="MM"
                          name="birthdateMM"
                          onChange={handleFieldChange}
                          defaultValue={formData.birthdateMM}
                          required
                        />
                      </Col>
                      <Col>
                        <Form.Control
                          maxLength="4"
                          size="lg"
                          type="text"
                          placeholder="YYYY"
                          name="birthdateYYYY"
                          onChange={handleFieldChange}
                          defaultValue={formData.birthdateYYYY}
                          required
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                </Col>
                <Col lg="4">
                  <Form.Group>
                    <Form.Label>Gender</Form.Label>
                    <Form.Select
                      size="md"
                      className="mb-3"
                      name="gender"
                      onChange={handleFieldChange}
                      defaultValue={formData.gender}
                    >
                      {genders.map((gender) => (
                        <option key={gender.value} value={gender.value}>
                          {gender.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                {/* <Col lg='4'>
                <Form.Group>
                  <Form.Label>Constituency</Form.Label>
                  <Form.Select
                    size='md'
                    className='mb-3'
                    name='constituency_id'
                    required
                    onChange={handleFieldChange}
                    defaultValue={constituencies.find(c => c.name === formData.constituencies)?.value}                  >
                    {constituencies.map((item) => (
                      <option
                        key={item.name}
                        value={item.value}
                      >
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col> */}
              </Row>

              <Row>
                <Col lg="6">
                  <Form.Group controlId="formFileLg" className="mb-3">
                    <Form.Label>Member&apos;s photo</Form.Label>
                    {/* {formData.profile_pic_url && formData.profile_pic_url?.includes('https') && (
                      <img src={formData.profile_pic_url} alt="profile" style={{ width: '100px', height: '100px' }} />
                    )} */}
                    {/* {formData?.profile_pic_url && !formData?.profile_pic_url?.includes('https')(
                    <img src={`${process.env.REACT_APP_DOCS_BASE_URL}/img/mpls/webp/${formData.profile_pic_url.split('.')[0]}.webp`} alt='profile' style={{ width: '100px', height: '100px' }} />)} */}

                    {formData.profile_pic_url && formData.profile_pic_url.includes('https') ? (
                      <img className="rounded" height={300} src={formData.profile_pic_url} alt={formData.name} />
                    ) : formData.profile_pic_url ? (
                      <img
                        className="rounded"
                        height={300}
                        src={`${process.env.REACT_APP_DOCS_BASE_URL}/img/mpls/webp/${
                          formData.profile_pic_url.split('.')[0]
                        }.webp`}
                        alt={formData.name}
                      />
                    ) : (
                      <>
                        No image
                        <br />
                      </>
                    )}
                    <FileUpload category={'news'} setFileUrl={setFileUrlImage} />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col lg="4">
                  <Form.Group>
                    <Form.Label>Status</Form.Label>
                    <Form.Select
                      size="md"
                      className="mb-3"
                      name="status"
                      onChange={handleFieldChange}
                      defaultValue={formData.status}
                    >
                      {statuses.map((status) => (
                        <option key={status.value} value={status.value}>
                          {status.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col lg="4">
                  <Form.Group>
                    <Form.Label>Party</Form.Label>
                    <Form.Select
                      size="md"
                      className="mb-3"
                      name="party_id"
                      onChange={handleFieldChange}
                      defaultValue={formData.party_id}
                    >
                      {parties.map((party) => (
                        <option key={party.value} value={party.value}>
                          {party.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col lg="4">
                  <Form.Group>
                    <Form.Label>Position</Form.Label>
                    <Form.Select
                      size="md"
                      className="mb-3"
                      name="position_id"
                      onChange={handleFieldChange}
                      defaultValue={formData.position_id}
                    >
                      {positions.map((position) => (
                        <option key={position.value} value={position.value}>
                          {position.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col lg="4">
                  <Form.Group>
                    <Form.Label>Telephone</Form.Label>
                    <Form.Control
                      size="lg"
                      type="text"
                      placeholder=""
                      name="tel"
                      onChange={handleFieldChange}
                      required
                      defaultValue={formData.tel}
                    />
                  </Form.Group>
                </Col>
                <Col lg="4">
                  <Form.Label>Cellphone 1</Form.Label>
                  <Form.Control
                    size="lg"
                    type="text"
                    placeholder=""
                    name="cell1"
                    onChange={handleFieldChange}
                    defaultValue={formData.cell1}
                  />
                </Col>
                <Col lg="4">
                  <Form.Label>Cellphone 2</Form.Label>
                  <Form.Control
                    size="lg"
                    type="text"
                    placeholder=""
                    name="cell2"
                    onChange={handleFieldChange}
                    defaultValue={formData.cell2}
                  />
                </Col>
              </Row>

              <Row>
                <Col lg="4">
                  <Form.Group>
                    <Form.Label>Email 1</Form.Label>
                    <Form.Control
                      size="lg"
                      type="email"
                      placeholder=""
                      name="email1"
                      onChange={handleFieldChange}
                      required
                      defaultValue={formData.email1}
                    />
                  </Form.Group>
                </Col>
                <Col lg="4">
                  <Form.Label>Email 2</Form.Label>
                  <Form.Control
                    size="lg"
                    type="text"
                    placeholder=""
                    name="email2"
                    onChange={handleFieldChange}
                    defaultValue={formData.email2}
                  />
                </Col>
                <Col lg="4">
                  <Form.Label>Website</Form.Label>
                  <Form.Control
                    size="lg"
                    type="text"
                    placeholder=""
                    name="website"
                    onChange={handleFieldChange}
                    defaultValue={formData.website}
                  />
                </Col>
              </Row>

              <Row>
                <Col lg="4">
                  <Form.Group>
                    <Form.Label>Facebook</Form.Label>
                    <Form.Control
                      size="lg"
                      type="text"
                      placeholder=""
                      name="facebook"
                      onChange={handleFieldChange}
                      defaultValue={formData.facebook}
                    />
                  </Form.Group>
                </Col>
                <Col lg="4">
                  <Form.Label>Twitter</Form.Label>
                  <Form.Control
                    size="lg"
                    type="text"
                    placeholder=""
                    name="twitter"
                    onChange={handleFieldChange}
                    defaultValue={formData.twitter}
                  />
                </Col>
                <Col lg="4">
                  <Form.Label>WhatsApp Number</Form.Label>
                  <Form.Control
                    size="lg"
                    type="text"
                    placeholder=""
                    name="whatsapp"
                    onChange={handleFieldChange}
                    defaultValue={formData.whatsapp ?? ''}
                  />
                </Col>
                <Col lg="4">
                  <Form.Label>preffered</Form.Label>
                  <Form.Select
                    size="md"
                    className="mb-3"
                    name="preffered"
                    onChange={handleFieldChange}
                    defaultValue={formData.preffered}
                  >
                    {commtypes.map((comm) => (
                      <option key={comm.value} value={comm.value}>
                        {comm.name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              </Row>

              <Row>
                <Col lg="6">
                  <Form.Group>
                    <Form.Label>Hierarchy Position on Members Page</Form.Label>
                    <Form.Control
                      size="lg"
                      type="text"
                      placeholder=""
                      name="hierarchy_position"
                      onChange={handleFieldChange}
                      defaultValue={formData.hierarchy_position}
                    />
                  </Form.Group>
                </Col>
                <Col lg="6">
                  <Form.Label>Hierarchy Position on Chairpersons page</Form.Label>
                  <Form.Control
                    size="lg"
                    type="text"
                    placeholder=""
                    name="hierarchy_chairperson_position"
                    onChange={handleFieldChange}
                    defaultValue={formData.hierarchy_chairperson_position}
                  />
                </Col>
              </Row>

              <Row>
                <Col lg="6" className="mt-4 mb-3 ml-3">
                  <Form.Group>
                    <IconButton
                      className="mb-1"
                      variant="falcon-default"
                      size="lg"
                      icon="plus"
                      transform="shrink-3"
                      type="submit"
                    >
                      Submit
                    </IconButton>
                  </Form.Group>
                </Col>
              </Row>
            </FalconComponentCard.Body>
          )}
        </Form>
      </FalconComponentCard>
    </>
  );
};

export default EditMember;
